import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useUserRole } from "@/hooks/useUserRole";
import { decideDriverRoute, DRIVER_LANDING_PATH } from "@/lib/driverRouteAccess";

/**
 * F-08B central driver route guard (UI layer only — RLS and Edge Function
 * authorisation remain the security boundary). Re-evaluates on every
 * location change, so direct URLs, refresh, deep links, push taps and
 * back/forward history are all covered. Redirect uses `replace` so the
 * blocked entry does not stay in history.
 */
export const DriverRouteGuard = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const { loading, isDriver } = useUserRole();
  const decision = decideDriverRoute({ pathname, roleLoading: loading, isDriver });

  if (decision === "redirect") return <Navigate to={DRIVER_LANDING_PATH} replace />;
  if (decision === "wait") {
    return (
      <div className="flex min-h-[50vh] items-center justify-center" role="status">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <span className="sr-only">Loading</span>
      </div>
    );
  }
  return <>{children}</>;
};
